import axios from 'axios';
import Cookie from 'js-cookie'
import Vue from 'vue';
import Vuesax from 'vuesax';

Vue.use(Vuesax)
import router from '../router/router';
import i18n from '../lang'; // Internationalization
const vue = new Vue({
  router,
  i18n
});
// console.log(vue.$i18n);
let showNoToken = true;
const service = axios.create({
  baseURL: process.env.VUE_APP_API || location.origin, // api 的 base_url
  timeout: 30000 // request timeout
});

function clearAndJump(){
  window.localStorage.clear();
  let selfQuery = {
    ...vue.$route.query,
  }
  if(vue.$route.name !== 'login'){
    selfQuery.redirectRouterName = vue.$route.name
  }
  router.push({
    name:'login',
    query: selfQuery,
    params: vue.$route.params,
  });
}

// request interceptor
service.interceptors.request.use(
  config => {
    config.data = JSON.stringify(config.data);

    config.headers = {
      "Content-Type":'application/json;charset=UTF-8',
    };
    //后台识别语言
    config.headers['Lang'] = Cookie.get('language') || 'zh_CN'
    let tokenX = localStorage.getItem('token');
    if(tokenX){
      config.headers['Authorization'] = "Bearer " + tokenX
    }
    let LOCALDOMAIN = 'http://maxportal.alitapro.com';
    // let LOCALDOMAIN = 'https://user.maxainasia.com';
    let domain = process.env.NODE_ENV == 'production' ? window.location.origin : LOCALDOMAIN;


    // config.headers['domainName'] = domain;
    if(domain.indexOf('https') > -1 && config.baseURL.indexOf('https') == -1){
      config.baseURL=config.baseURL.replace('http','https');
    }
    return config;
  },
  error => {
    console.log('requestErr' + error); // for debug
    Promise.reject(error);
  }
);

function signOutAndPrompts(){
  if(showNoToken){
      showNoToken = false;
      clearAndJump();
      vue.$message.error("登录超时，请重新登录");
  }

}

// response interceptor
service.interceptors.response.use(
  response => {
    //用户不存在
    if(response.data.status == 10005){
        signOutAndPrompts();
        return response.data;
    }
    if(response.config.url.includes("ipinfo.io")){
      return response.data;
    }

    if (response.data.status !== 10000) {
      // 样式层级不够高 todo 翻译,
      // 不需要额外的标题和按钮 todo,需要选一个message
      vue.$vs.dialog({
        title: vue.$i18n.t('Notice'),
        text: response.data.message,
        acceptText: vue.$i18n.t('root.confirm')
      });
      return Promise.reject(response);
    }
    if(response.data.type==2){
      response.data.data = response.data.data.content;
    }else if(response.data.type==3){
      response.data.data = response.data.data.content[0]
    }
    if(response.config.url.includes("fp/login")){
      showNoToken = true; 
    }
    return response.data;
  },
  error => {
    console.log(error);
    const errStatus = error.response && error.response.status;
    if(errStatus == 401){
      //区分没有登录和登录过token失效
      if(!localStorage.getItem('token') && vue.$route.name != 'login' && showNoToken){
        showNoToken = false;
        vue.$router.push({name: 'login'});
      }else {
        //  登录异常
        if(showNoToken){
          showNoToken = false;
          clearAndJump();
          vue.$message.error("登录超时，请重新登录");
        }
      }
    }else{
      
      console.error(error);
    }

    return Promise.reject(error);
  }
);
export default service;
